import picsioConfig from '../../../../config';

import { deselectAllProducts } from '../store/products/deselectAllProducts';
import deselectAll from '../store/actions/assets/deselectAll';
import deselectAllByMatch from '../store/actions/assets/deselectAllByMatch';
import l10n from '../shared/strings';
import { showDialogAsync } from '../components/dialog';

const strings = l10n.PRODUCTS_BULK_SELECTION.switchLayer;

const hasProductSelection = (state) => (
  (state.products?.ui?.selection?.keys?.length || 0) > 0
);

const hasAssetSelection = (state) => {
  const assets = state.assets || {};
  return (assets.selectedItems?.length || 0) > 0
    || (assets.selectedItemsToMatch?.length || 0) > 0;
};

async function confirmSwitchLayer() {
  try {
    await showDialogAsync({
      title: strings.title,
      text: strings.text,
      textBtnOk: strings.btnConfirm,
      textBtnCancel: strings.btnCancel,
    }).promise;
    return true;
  } catch {
    return false;
  }
}

export default async function confirmAndClearOtherSelectionLayer({
  dispatch,
  getState,
  targetLayer,
}) {
  const state = getState();

  if (targetLayer === 'assets') {
    if (!hasProductSelection(state)) return true;
    if (!(await confirmSwitchLayer())) return false;
    dispatch(deselectAllProducts());
    return true;
  }

  if (!hasAssetSelection(state)) return true;
  if (!(await confirmSwitchLayer())) return false;
  await dispatch(deselectAll({ deselectAllFromClipboard: true }));
  if (picsioConfig.isPim) {
    dispatch(deselectAllByMatch());
  }
  return true;
}
